import React, { useCallback } from "react";
import { Link } from "react-router-dom";
import { useAppDispatch } from "../../../../../state/store";
import { clearKeywordAction } from "../../../../../state/usecase/disease_knowledge/actions";
import { useSearchedDiseases } from "../../../../hooks/disease_knowledge/useSearchedDiseases";

export const ResultCount = React.memo(function ResultCount() {
    const dispatch = useAppDispatch();

    const { keyword, resultList } = useSearchedDiseases();

    const onClickClearKeyword = useCallback(() => {
        dispatch(clearKeywordAction());
    }, [dispatch]);

    return (
        <h3 className={"resultCount"}>
            <span>[{keyword}]の検索結果({resultList.length}件)</span>
            <Link className={"clearKeyword"} to={"#"} onClick={onClickClearKeyword}>検索結果をクリア</Link>
        </h3>
    );
});
